import { useMutation } from '@tanstack/react-query';
import { queryClient } from '../../main';
import { toast } from 'react-toastify';
import { createPlantillaSemanal, deletePlantillaSemanal, updatePlantillaSemanal } from '../api';

// Mutación para crear una plantilla semanal
export const useCreatePlantillaSemanalMutation = () => useMutation({
    mutationFn: createPlantillaSemanal,
    onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['plantillasSemanales'] });
        toast.success('Plantilla semanal creada exitosamente');
    },
    onError: () => {
        toast.error('Error creando la plantilla semanal');
    },
});

// Mutación para actualizar una plantilla semanal
export const useUpdatePlantillaSemanalMutation = () => useMutation({
    mutationFn: updatePlantillaSemanal,
    onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['plantillasSemanales'] });
        toast.success('Plantilla semanal actualizada exitosamente');
    },
    onError: () => {
        toast.error('Error actualizando la plantilla semanal');
    },
});

// Mutación para eliminar una plantilla semanal
export const useDeletePlantillaSemanalMutation = () => useMutation({
    mutationFn: deletePlantillaSemanal,
    onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['plantillasSemanales'] });
        toast.success('Plantilla semanal eliminada exitosamente');
    },
    onError: () => {
        toast.error('Error eliminando la plantilla semanal');
    },
});